import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import {
  API_BASE_CRM_URL,
  API_BASE_URL,
  IMAGE_URL_IBIZ,
} from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";

export default function Brands() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [brandData, setbrandData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [userDataSession, setUserDataSession] = useState({});
  const { setID } = useLabelContext();

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getBrands?OrgId=${userDataSession.OrgId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setbrandData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setbrandData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };
    if (userDataSession?.OrgId) {
      fetchData();
    }
  }, [userDataSession.OrgId]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = brandData.filter(
      (item) =>
        item.Name && item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setCurrentPage(1);
    return results;
  }, [brandData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-3">
            <h4>Brands</h4>
            <h6>Manage your Brands</h6>
          </div>
          <div className="search-bar mb-3 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-container mb-0" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          currentItems &&
          currentItems.map((item, index) => (
            <div
              key={index}
              className="product-card card shadow-sm my-2"
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "15px",
                marginTop: "-20px",
              }}
            >
              <div className="card-body" style={{ padding: "1px" }}>
                <div
                  className="d-flex"
                  style={{
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  {item.ImagePath ? (
                    <img
                      src={`${IMAGE_URL_IBIZ}${item.ImagePath}`}
                      alt="Item Image"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#ffffff",
                        backgroundColor: "#007bff",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {item.Name.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div style={{ color: "#6c757d" }}>
                    <h5
                      className="card-title"
                      style={{
                        color: "#007bff",
                        fontSize: "16px",
                        marginBottom: "6px",
                      }}
                    >
                      {item.Name}
                    </h5>
                    <div style={{ fontSize: "12px" }}>
                      <strong>
                        <i
                          className="fa-solid fa-qrcode"
                          style={{ color: "#007bff" }}
                        ></i>
                      </strong>{" "}
                      {item.Code}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={brandData.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
      <br />
      <br />
      <br />
      <Footer></Footer>
    </Base>
  );
}
